module.exports = __webpack_public_path__ + "static/media/shreya_vaidya.c389b7a3.jpg";